export let NAVIGATION_ARROWS_POSITION;
(function (NAVIGATION_ARROWS_POSITION) {
  NAVIGATION_ARROWS_POSITION[NAVIGATION_ARROWS_POSITION["OUTSIDE"] = 0] = "OUTSIDE";
  NAVIGATION_ARROWS_POSITION[NAVIGATION_ARROWS_POSITION["INSIDE"] = 1] = "INSIDE";
})(NAVIGATION_ARROWS_POSITION || (NAVIGATION_ARROWS_POSITION = {}));
//# sourceMappingURL=navigation-arrows-position.js.map